// extracted by mini-css-extract-plugin
export default {"coverImage":"App_coverImage__wtv3E","loaderContainer":"App_loaderContainer__7Zo9Y","loader":"App_loader__SbZCZ","progress":"App_progress__e2mDn"};